import EditIncome from '../../pages/Transactions/EditIncome';
import { TransactionsController } from '../../controllers';
import { appStore, useStores } from '../../stores';
import { MimaToastUtil } from '../../components';
import { string, object, number } from 'yup';
import constant from '../../utils/constant';
import React, { useState } from 'react';
import { observer } from 'mobx-react';

const EditIncomeContainer = ({ closeModal }) => {
	const [openIncomeModal, setOpenIncomeModal] = useState(true);
	const [incomeSuccess, setIncomeSuccess] = useState(false);
	const [toggle, setToggle] = useState(false);
	let {
		appStore: { loading },
	} = useStores();

	const getAddedIncome = () => {
		setOpenIncomeModal(false);
		setIncomeSuccess(true);
	};

	const addAnotherIncome = () => {
		setOpenIncomeModal(true);
		setIncomeSuccess(false);
	};

	const getToggle = () => {
		setToggle(!toggle);
	};
	const validationSchema = () => {
		return object({
			transactionAmount: number()
				.required()
				.min(1, 'The minimum transaction amount should be 1'),
			narration: string().required('Service Rendered is required'),
			paidDate: string().required('Paid date is required'),
			paymentMethod: string().required('Payment Method is required'),
		});
	};

	const onSubmit = async values => {
		let payload = {};

		appStore.setLoading(true);
		if (!values.customer) {
			delete values.customer;
		}

		payload = {
			...values,
			paidDate: values.paidDate.toDateString(),
		};

		const { status, errorMessage } = await TransactionsController.postIncome(
			payload
		);
		appStore.setLoading(false);
		if (status === constant.Success) {
			MimaToastUtil.success({
				message: constant.Success,
			});
			return getAddedIncome();
		}
		return MimaToastUtil.error({
			message: errorMessage,
		});
	};

	return (
		<EditIncome
			closeModal={closeModal}
			openIncomeModal={openIncomeModal}
			getToggle={getToggle}
			toggle={toggle}
			loading={loading}
			validationSchema={validationSchema}
			onSubmit={onSubmit}
			incomeSuccess={incomeSuccess}
			addAnotherIncome={addAnotherIncome}
		/>
	);
};

export default observer(EditIncomeContainer);
